module.exports = __webpack_public_path__ + "static/media/blog2.705c928e.png";